import { useState, useEffect, useRef } from "react";
import Icon from "../../assets/icons/Icon";

const ExportButton = ({ onExport,loading }) => {
  const [showExportOptions, setShowExportOptions] = useState(false);
  const [exportSelectedOption, setExportSelectedOption] = useState("");
  const dropdownRef = useRef(null);
  
  const exportOptions = [
    // { label: "PDF", value: "PDF" },
    { label: "EXCEL", value: "EXCEL" },
    {label:"CSV",value:"CSV"}
  ];

  const handleExportOptionSelect = (value) => {
    setExportSelectedOption(value);
    setShowExportOptions(false);
    if (onExport) {
      onExport(value); // Pass the selected value to parent
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowExportOptions(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="flex"> 
      <div className="relative mt-auto flex" ref={dropdownRef}>
        <span className="block">
          <button
            onClick={() => {!loading && setShowExportOptions(!showExportOptions)}}
            className={`${loading ? "bg-green-600" :"bg-green-500 hover:bg-green-600 cursor-pointer"} h-[34px] px-4 text-white  rounded-lg flex items-center justify-center text-bold`}
            style={{ width: "auto" }}
          >
            <div className="w-5 mr-[4px]">
              <Icon type={"file"} />
            </div>
            {loading ? "Exporting..." :"Export: "}<span className="pl-1"> {exportSelectedOption || "Select"}</span>
            
            <span className="w-2.5 flex inline-block mb-0.5 ml-1">
              <Icon type="downarrownew" />
            </span>
          </button>

          {showExportOptions && (
            <div
              className="absolute z-30 mt-1.5 rounded-lg shadow-lg bg-white w-full"
              style={{
                top: "100%",
                left: 0,
                boxShadow: "0 2px 10px rgba(215, 213, 226, 0.5), 0 4px 6px rgba(0, 0, 0, 0.1)",
              }}
            >
              {exportOptions.map((option, index) => (
                <div
                  key={index}
                  onClick={() => handleExportOptionSelect(option.value)}
                  className={`flex items-center justify-between px-2 py-2 cursor-pointer ${
                    exportSelectedOption === option.value
                      ? "bg-[#F5EBFB] text-[#6e2d90]"
                      : "hover:bg-[#6E2D90] hover:text-white"
                  }`}
                >
                  <span>{option.label}</span>
                  {exportSelectedOption === option.value && (
                    <span className="w-3 text-[#6e2d90] ml-2">
                      <Icon type="check" />
                    </span>
                  )}
                </div>
              ))}
            </div>
          )}
        </span>
      </div>
    </div>
  );
};

export default ExportButton;